export default __webpack_public_path__ + "static/media/david.f89ba1b5.png";